import { faEnvelope, faGlobe, faPhone } from '@fortawesome/pro-solid-svg-icons';
import { Image, Logo, TSubscriptionLevel } from '@nettbureau/featured-core';
import { Spacer } from '@nettbureau/vibrant-ui';
import { CardAction } from './CardAction';
import { CardActions } from './CardActions';
import { CardBackground } from './CardBackground';
import { CardBody } from './CardBody';
import { CardContactDetails } from './CardContactDetails';
import { FeaturedCard } from './FeaturedCard';

export function ContactCard({
  id,
  title,
  href,
  subTitle,
  bodyLine1,
  bodyLine2,
  phone,
  email,
  icon,
  website,
  background,
  center,
  logo,
  subscriptionLevel,
  minHeight,
}: ContactCardProps) {
  return (
    <FeaturedCard minHeight={minHeight}>
      <CardBackground
        id={id}
        icon={icon ?? null}
        center={center ?? null}
        logo={subscriptionLevel === 'premium' && logo ? logo : null}
        background={background}
      />

      <CardBody>
        <CardContactDetails
          title={title}
          href={href}
          bodyLine2={bodyLine2}
          bodyLine1={bodyLine1}
          subTitle={subTitle}
        />
      </CardBody>

      <Spacer></Spacer>

      {subscriptionLevel === 'premium' ? (
        <CardActions>
          {email && (
            <CardAction
              openTab={false}
              icon={faEnvelope}
              ariaLabel="Email"
              href={`mailto:${email}`}
            />
          )}
          {phone && (
            <CardAction
              openTab={false}
              icon={faPhone}
              ariaLabel="Call"
              href={`tel:${phone}`}
            />
          )}
          {website && (
            <CardAction
              openTab={true}
              icon={faGlobe}
              ariaLabel="Visit website"
              href={website}
            />
          )}
        </CardActions>
      ) : null}
    </FeaturedCard>
  );
}

interface ContactCardProps {
  /** Determines the minimum height of the card. */
  minHeight?: number;
  /** Determines the subscription level of the company. */
  subscriptionLevel: TSubscriptionLevel;
  /** ContactCard id prop. */
  id: number;
  /** ContactCard title prop. */
  title: string;
  /** ContactCard subtitle prop. */
  subTitle: string | null;
  /** ContactCard bodyline1 prop. */
  bodyLine1: string | null;
  /** ContactCard bodyline2 prop. */
  bodyLine2: string | null;
  /** ContactCard phone number action. */
  phone: string | null;
  /** ContactCard email action. */
  email: string | null;
  /** ContactCard website action. */
  website: string | null;
  /** Center image URL. */
  center: Image | null;
  /** Icon URL. */
  icon: Image | null;
  /** Logo. */
  logo: Logo['logo'];
  /** Link to page. */
  href: string | null;
  /** Background URL. */
  background: Image | null;
}
